import React from "react";

import { ActionText, Box, Flex } from "../../components/Flex";
import { Title } from "../../components/Text";
import { UploadProgressRow } from "./UploadProgressRow";
import { UploadIcon } from "../../icons/UploadIcon";
import { TopIconButton } from "../../icons/IconContainer";
import { Popover } from "../../components/Popover";
import { Scrollbar } from "../../components/Scrollbar";
import { filter, size } from "lodash";



const UploadProgress = ({ uploads, onClearUploads }) => {
    const calculateHeight = () => {
        const max = 303;
        let height = 34 + size(uploads)*55 + 22 + 31;
        if (height > max) height = max;
        return height + "px";
    };

    const content = <Box
        width="325px"
        height={calculateHeight()}
        borderRadius={8}
        gap={{ bottom: 12 }}
        background="var(--sp-light-grey-blue-color)"
        padding={{ left: "21px", "top": "11px", right: "5px", bottom: "20px" }}
        style={{ boxShadow: "0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)" }}
    >
        <Title h6 >Recent upload history</Title>
        <Scrollbar>
            <Flex direction="column" gap={{ bottom: 12 }} padding={{ right: "15px"}}>
                {Object.keys(uploads).map(uploadKey => <UploadProgressRow key={uploadKey} {...uploads[uploadKey]} />)}
                {filter(Object.values(uploads), up => up.status != 3).length ? <ActionText onClick={onClearUploads}>Remove completed</ActionText> : null}
            </Flex>
        </Scrollbar>
    </Box>;


    return(
        <Popover content={content}>
            <TopIconButton>
                <UploadIcon color="var(--sp-main-color)" />
            </TopIconButton>
        </Popover>
    );
};

export { UploadProgress };